<template>
    <div>
        <div class="col-12 text-center" v-if="shipments.length < 1">
            <button
                @click.prevent="add(null)"
                class="btn btn-red w-50"
            >
                {{ __('Add shipment') }}
            </button>
        </div>

        <ShipmentTypeRow
            :shipmentType="shipmentType"
            :can-add="shipments.length === index + 1"
            :can-remove="shipments.length > 1"
            :index="index"
            :key="index"
            :load="shipment"
            :scope="`shipments-${index}`"
            :shipment="shipment"
            @add="add"
            @remove="remove"
            v-for="(shipment, index) in shipments"
        />
    </div>
</template>

<script>
import ShipmentUnit from '../../models/ShipmentUnit'
import ShipmentTypeRow from './ShipmentTypeRow'

export default {
  name: 'ShipmentsForm',

  inject: ['$validator'],

  components: {
    ShipmentTypeRow
  },

  props: {
    shipments: Array,
    shipmentType: String
  },

  methods: {
    add (shipment = null) {
      this.shipments.push(shipment || new ShipmentUnit({}))
    },

    remove (index) {
      this.shipments.splice(index, 1)
    }
  }
}
</script>
